// Shared Framer Motion variants — premium editorial easing
export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { y: 40, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { duration: 0.8, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.9, ease: EASE } },
};

export const staggerContainer = (stagger = 0.12, delay = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren: stagger, delayChildren: delay } },
});

export const scaleIn = {
  hidden: { scale: 0.94, opacity: 0 },
  show: { scale: 1, opacity: 1, transition: { duration: 0.7, ease: EASE } },
};

// Masked line reveal for the kinetic hero
export const lineMask = {
  hidden: { y: '110%' },
  show: (i = 0) => ({
    y: '0%',
    transition: { duration: 1, ease: EASE, delay: 0.15 + i * 0.12 },
  }),
};

export const viewport = { once: true, amount: 0.25 };
